
export default function Footer(){
    return(
        <footer class="bg-[#111827]  m-4 rounded-lg">
            <div class="w-full max-w-screen-xl mx-auto p-4 md:py-8">
                <span class="block text-sm text-gray-500 sm:text-center dark:text-gray-400">© 2023 <a href="https://chatwith.io/s/kerlos-magdy" class="hover:underline">Kerlos Magdy</a>. All Rights Reserved.</span>
            </div>
        </footer>
    )
}